import { deepClone } from './deckHelpers';

const KNOWN_OLD_VERSIONS = new Set(['3.5.0', '3.0.0']);

const error = (path, code, message) => ({ path, code, message });

export const migrateDeckTo400 = (deck) => {
  const migrations = [];
  const errors = [];
  const working = deepClone(deck);

  const sourceVersion = working?.version;
  if (!sourceVersion) {
    errors.push(error('version', 'VERSION_UNSUPPORTED', 'Missing version; expected 4.0.0.'));
    return { ok: false, errors };
  }

  if (sourceVersion === '4.0.0') {
    return { ok: true, deck: working, migrations };
  }

  if (!KNOWN_OLD_VERSIONS.has(sourceVersion)) {
    errors.push(error('version', 'VERSION_UNSUPPORTED', `Unsupported version "${sourceVersion}". Required "4.0.0".`));
    return { ok: false, errors };
  }

  working.version = '4.0.0';
  if (working.schema_type !== 'full_deck') {
    working.schema_type = 'full_deck';
  }
  if (working.format !== 'boppps_lesson') {
    working.format = 'boppps_lesson';
  }
  migrations.push({
    path: 'version',
    action: 'upgrade',
    detail: `Migrated from ${sourceVersion} to 4.0.0`
  });

  return { ok: true, deck: working, migrations };
};

